// Use $ instead of $ without replacing global $
(function ($) {
  if ($('.col-two-grid').length > 0) {

    /* Load more click count. */
    var item_show = 6,
      length = '';

    /* Function to hide and show element on Load */
    function load_OnReady() {
      $('.col-two-grid .brand-wrapper').find('.card-box').each(function () {
        length = $(this).parents('.col-two-grid .brand-wrapper').find('.card-box').length;
        // console.log(length);
        var index = $(this).index();
        // console.log(this);
        if (index >= item_show) {
          $(this).css('display', 'none').removeClass('active-filter');
        } else {
          $(this).css('display', 'block').addClass('active-filter');
        }
        if (length <= item_show) {
          $(this).parents('.col-two-grid').find('.load-more').css('display', 'none');
        } else {
          $(this).parents('.col-two-grid').find('.load-more').css('display', 'inline-block');
        }
      });
    }

    /* Function to show element on Load more click */
    function loadMore() {
      var $i = 0;
      $('.col-two-grid .brand-wrapper .card-box').each(function () {
        var $dataDisplay = $(this).css('display');
        if ($dataDisplay == 'block') {
          $i++;
        }
      });
      if ($i < length) {
        for (var $j = $i; $j < ($i + item_show); $j++) {
          // $('.column-grid .grid-outer .card').eq($j).css({'display': 'block'});
          $('.col-two-grid .brand-wrapper .card-box').css({
            'display': 'block'
          });
          $('.col-two-grid .load-more').css({
            'display': 'none'
          });

          if (($i + item_show) >= length) {
            $('.col-two-grid .load-more').css({
              'display': 'none'
            });
          }
        }
      } else {
        $('.col-two-grid .load-more').css({
          'display': 'none'
        });
      }
    }

    function wrappBlock() {
      if ($('.col-two-grid .child_term ul li').length > 0) {
        var len = $('.col-two-grid .child_term ul li').length;
        $('.col-two-grid .child_term ul').clone().appendTo('.col-two-grid .custom');
      } else {
        $("body .col-two-grid .views-exposed-form select").clone().appendTo('.col-two-grid .heading .filter-box');
        setTimeout(function () {

          var test = $("body .col-two-grid .heading ul").html();
          $(test).clone().appendTo('.col-two-grid .heading .custom ul');
          $('.col-two-grid .custom ul li').first().remove();
          $('.col-two-grid .custom ul li a span').remove();

          var list = $(".col-two-grid .custom ul li").length;
          if (list > 0) {
            $('.col-two-grid .filter-box').remove();
            // $('.col-two-grid .back-link').remove();
          } else {
            $('.col-two-grid .custom').remove();
          }
        }, 500);
      }

    }


    var f = 0,
      f1 = 0;
    $(document).ready(function () {
      wrappBlock();
      setURL();
      $(".col-two-grid .custom .caret").click(function () {
        $('.col-two-grid .custom .caret').toggleClass('active')
        $('.col-two-grid .custom ul').toggle();
      });
    });

    $(window).resize(function () {
      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f1 === 0) {
          load_OnReady();
          f1 = 1;
        }
      }
    });

    $(document).on('click', '.col-two-grid .load-more', function () {
      loadMore();
    });


    // var body_attr1;
    //
    // function set_content() {
    //   setTimeout(function () {
    //     body_attr1 = $('body').attr('data-region');
    //
    //     $('body .col-two-grid.region .brand-wrapper .card-box').each(function () {
    //       var $data = $(this).attr('data-region');
    //       if (body_attr1 === $data || $data === "all") {
    //         $(this).addClass("active");
    //       } else {
    //         $(this).remove();
    //       }
    //     });
    //   }, 2000);
    // }

    // set_content();

    var item_length = $('body .col-two-grid  .views-exposed-form .form-item-field-product-type-target-id select option').length;
    if (item_length <= 1) {
      $('body .col-two-grid').addClass('hide-select');
    }

    $(document).on('change', '.col-two-grid:not(.product_anchor_filter) .heading select', function (e) {
      var value = $(this).val();
      var value2 = $('#views-exposed-form-product-type-child-block-1 .form-item-field-product-type-target-id select').val();

      if (value !== value2) {
        $('#views-exposed-form-product-type-child-block-1 .form-item-field-product-type-target-id select').val(value).trigger('change');
        $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      }

      // set_content();

      var winWidth = $(window).width();
      if (winWidth < 768) {
        setTimeout(function () {
          load_OnReady();
        }, 2000);
      }
    });
  }

  function setText() {
    setTimeout(function () {
      var text = "All";
      $('body .col-two-grid .selectboxit-container #edit-field-product-type-target-idSelectBoxIt #edit-field-product-type-target-idSelectBoxItText').html(text);
      $('body .col-two-grid .selectboxit-container #edit-field-product-type-target-idSelectBoxItOptions .selectboxit-option-first .selectboxit-option-anchor').html(text);
    }, 500);
  }

  function setURL() {
    if (!$('.col-two-grid .child_term ul li').length > 0) {
      setTimeout(function () {
        var text, term_id;
        text = "/taxonomy/term/";
        $('.custom li').each(function () {
          var term = $(this).attr('data-val');
          $(this).find('a').attr("href", text + term);
        });
      }, 500);
    }
  }

  $(document).ready(function () {
    setText();
  });

  $(window).on('load', function () {
    if ($('.col-two-grid').length > 0) {
      // Change the col-two-grid based on Region
      var val_au, val_in, val_af, val_nz, val_cn, val_excn, val_mx;
      val_au = 43;
      val_in = 44;
      val_af = 47;
      val_nz = 48;
      val_cn = 756;
      val_excn = 715;
      val_mx = 757;

      var geo = $('body').attr('data-region');
      // if (geo == 'australia') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_au + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      //   // console.log(1);
      // } else if (geo == 'new_zealand') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_nz + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      //   // console.log(2);
      // } else if (geo == 'in') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_in + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      //   // console.log(3);
      // } else if (geo == 'africa') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_af + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      //   // console.log(4);
      // } else if (geo == 'china') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_cn + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      //
      // }else if (geo == 'mexico') {
      //   $('#views-exposed-form-product-type-child-block-1 .form-item-field-region-target-id  option[value=' + val_mx + ']').attr('selected', true);
      //   $('#views-exposed-form-product-type-child-block-1 .form-submit').trigger('click');
      // } else {
      //
      // }

      $('.col-two-grid .brand-wrapper .card-box').each(function () {
        $(this).removeClass('New');
        if ($(this).hasClass('Australia') && (geo == 'australia')) {

        } else if ($(this).hasClass('Zealand') && (geo == 'new_zealand')) {

        } else if ($(this).hasClass('India') && (geo == 'in')) {

        } else if ($(this).hasClass('Africa') && (geo == 'africa')) {

        } else if ($(this).hasClass('Mexico') && (geo == 'mexico')) {

        } else if ($(this).hasClass('China') && (geo == 'china')) {

        } else if ($(this).hasClass('ExcludeChina') && (geo != 'china')) {

        } else if ($(this).hasClass('us')) {

        } else {
          $(this).remove();
        }
      });


      var winWidth = $(window).width();
      if (winWidth < 768) {
        if (f === 0) {
          setTimeout(function () {
            load_OnReady();
            f = 1;
          }, 1500);
        }
      }
    }
  });

})(jQuery);